import {
    BRAND_MASTER_USERFORM_RESET,
    CREATE_BRAND_MASTER_FAILURE,
    CREATE_BRAND_MASTER_REQUEST,
    CREATE_BRAND_MASTER_SUCCESS,
    CREATE_USER_FORM_BRAND_MASTER,
    DELETE_BRAND_MASTER_FAILURE,
    DELETE_BRAND_MASTER_REQUEST,
    DELETE_BRAND_MASTER_SUCCESS,
    FETCH_BRAND_MASTER_FAILURE,
    FETCH_BRAND_MASTER_REQUEST,
    FETCH_BRAND_MASTER_SUCCESS,
    FETCH_BUYER_NAME_MASTER_FAILURE,
    FETCH_BUYER_NAME_MASTER_REQUEST,
    FETCH_BUYER_NAME_MASTER_SUCCESS,
    FETCH_SINGLE_BRAND_MASTER_FAILURE,
    FETCH_SINGLE_BRAND_MASTER_REQUEST,
    FETCH_SINGLE_BRAND_MASTER_SUCCESS,
    UPDATE_BRAND_MASTER_FAILURE,
    UPDATE_BRAND_MASTER_REQUEST,
    UPDATE_BRAND_MASTER_SUCCESS
} from './brandMaster.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchPartyDetailsData } from '../partyDetails/partyDetails.action';

// FETCH BrandMaster
export let fetchBrandMaster = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.brandMasterGET}`,
        responseTypeRequest: FETCH_BRAND_MASTER_REQUEST,
        responseTypeSuccess: FETCH_BRAND_MASTER_SUCCESS,
        responseTypeFailure: FETCH_BRAND_MASTER_FAILURE
    };
    return axiosCall(config);
};
export let fetchBuyerName = (fieldName) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.buyerNameGET}?FldControllerName=${fieldName}`,
        responseTypeRequest: FETCH_BUYER_NAME_MASTER_REQUEST,
        responseTypeSuccess: FETCH_BUYER_NAME_MASTER_SUCCESS,
        responseTypeFailure: FETCH_BUYER_NAME_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE BrandMaster
// "fldBrandName": "PlusFit",
//   "fldIsActive": true,
//   "fldEnteredSysId": "192.16.7.89",
//   "fldCreatedBy": 1,
//   "fldCreatedDt": "2022-07-12T06:26:36.359Z",
//   "fldFKBuyerName": 2
export let createBrandMaster = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldBrandName: formData.brand,
        fldFKBuyerName: formData.buyerName === '' ? 0 : parseInt(formData.buyerName),
        fldBrandType: formData.brandType,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.brandMasterPOST}`,
        responseTypeRequest: CREATE_BRAND_MASTER_REQUEST,
        responseTypeSuccess: CREATE_BRAND_MASTER_SUCCESS,
        responseTypeFailure: CREATE_BRAND_MASTER_FAILURE,
        resetFormData: BRAND_MASTER_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchBrandMaster(),
        singlApiArray: [createBrandMasterUserForm('brandType', 'O')]
    };
    return axiosCall(config);
};

// GET SINGLE StyleMaster
export let getSingleBrandMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.brandMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_BRAND_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_BRAND_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_BRAND_MASTER_FAILURE,
        singlApiArray: [fetchPartyDetailsData()]
    };
    return axiosCall(config);
};

//UPDATE BrandMaster
// "fldId": 7,
//     "fldBrandName": "PlusFit1",
//     "fldBrandType": "C",
//     "fldIsActive": true,
//     "fldEnteredSysId": "string",
//     "fldCreatedBy": 1,
//     "fldCreatedDt": "2022-07-14T11:07:05.34",
//     "fldModifiedBy": null,
//     "fldModifiedDt": null,
//     "fldFKBuyerName": 1
export let updateBrandMaster = (id, formData) => {
    let today = new Date();
    let data = {
        fldId: id,
        fldBrandName: formData.brand,
        fldBrandType: formData.brandType,
        fldFKBuyerName: formData.brandType == 'O' ? 0 : parseInt(formData.buyerName),
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString()
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.brandMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_BRAND_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_BRAND_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_BRAND_MASTER_FAILURE,
        resetFormData: BRAND_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchBrandMaster()
    };
    return axiosCall(config);
};

// DELETE StyleMaster
export let deleteBrandMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.brandMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_BRAND_MASTER_REQUEST,
        responseTypeSuccess: DELETE_BRAND_MASTER_SUCCESS,
        responseTypeFailure: DELETE_BRAND_MASTER_FAILURE,
        resetFormData: BRAND_MASTER_USERFORM_RESET,
        modalClose: true,
        getAllData: fetchBrandMaster()
    };
    return axiosCall(config);
};

export let createBrandMasterUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_BRAND_MASTER, payload: { key, value } });
    };
};
